import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e54abcac&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e54abcac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54abcac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e54abcac')) {
      api.createRecord('e54abcac', component.options)
    } else {
      api.reload('e54abcac', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e54abcac&scoped=true&", function () {
      api.rerender('e54abcac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f1zlIczwxeZa/JS/comp/PopupBox.vue"
export default component.exports